<template>
  <AppHome>
    <div slot="main">
      <section>
        <List>
          <ListItemWithIcon slot="list-item" icon-position="left">
            <img slot="list-item-icon" src="~assets/images/icons/ic-fdm-apple/ic-fdm-apple.png">
            <div slot="list-item-text">
              <span v-if="card.is_expiration_frozen">
                Nous sommes désolés, votre carte {{ programName }} a expiré,
                rendez-vous sur l'application FidMarques pour pouvoir la renouveler.
              </span>
              <span v-else-if="card.is_opted_out_after_expiration">
                Nous sommes désolés, votre carte {{ programName }} a expiré<!--
                --><span v-if="isProgramClosing"> et le programme {{ programName }} ferme ses portes</span><!--
                -->.
                Retrouvez d'autres programmes de grandes marques sur l'application FidMarques.
              </span>
              <span v-else-if="card.is_opted_out_by_user">
                Nous sommes désolés, vous n'avez plus la carte {{ programName }}
                car vous vous en êtes désincrit, rendez-vous sur l'application FidMarques
                pour retrouver vos autres programmes de fidélité.
              </span>
              <span v-else>
                Nous sommes désolés, vous n'avez pas la carte {{ programName }},
                rendez-vous sur FidMarques pour retrouver vos autres programmes de fidélité.
              </span>
            </div>
          </ListItemWithIcon>
        </List>
      </section>
    </div>
  </AppHome>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AppHome   from '~/components/layout/Home'
import List              from '~/components/elements/List'
import ListItemWithIcon  from '~/components/elements/ListItemWithIcon'
export default {
  components: {
    AppHome,
    List,
    ListItemWithIcon,
  },
  computed: {
    ...mapState('server', ['programName']),
    ...mapGetters('card', ['card']),
    ...mapGetters('server', ['isProgramClosing']),
  },
}
</script>
